export const defaultThermometerValue = () => {
    return {
      type: null,
      start: 0,
      end: 40,
      stepsize: 5,
      styles: { bg_color: "#f00", border_color: "#000" },
      fill_upto: 3,
      num_lines: 0,
      design_type: "D1",
      box_styles: { bg_color: "#caffbf" },
    };
}